export default __webpack_public_path__ + "static/media/Empty-List-Search-Domain_Icon.ba1664e7.svg";